<template>
	<div v-show="parcela">
		<div class="iconBoxBack" @click="$emit('backOption')" :style="parceiro ? { color: parceiroConfig.estilo.corPrimaria } : { color: 'var(primaryColor' }">
			<i class="fas fa-chevron-left" />
			Voltar
		</div>
		<template v-if="parcela.tipo_parcela === 'boleto'">
			<h3 v-if="parcela.pra_quantidade === 0" class="titleOption">Confirmação de pagamento (R$ {{ money2(parcela.valor_total) }} à vista) {{ parcela.valorFuturoIncluso ? " (incluso lançamento futuro de R$" + parcela.valorFuturoTotal + ")" : "" }}</h3>
			<h3 v-else-if="parcela.valor_entrada" class="titleOption">
				{{ parcela.valor_entrada ? `Confirmação de pagamento (Entrada de R$ ${parcela.valor_entrada} +` : "Confirmação de pagamento " }}
				{{ `${parcela.pra_quantidade}x de R$ ${parcela.valor_parcela})` }} {{ parcela.valorFuturoIncluso ? " (incluso valor lançamento futuro de R$" + parcela.valorFuturoTotal + ")" : "" }}
			</h3>
			<h3 v-else class="titleOption">{{ `Confirmação de pagamento (${parcela.pra_quantidade}x de R$ ${parcela.valor_parcela})` }} {{ parcela.valorFuturoIncluso ? " (incluso valor lançamento futuro de R$" + parcela.valorFuturoTotal + ")" : "" }}</h3>
			<div class="infos-row" v-if="parcela">
				<div class="infos">
					<h6>Forma de pagamento</h6>
					<h2>{{ formaPagamentoFormatada }}</h2>
				</div>
				<div class="infos">
					<h6>Primeiro vencimento</h6>
					<h2>{{ parcela.pra_primeiro_vcto.split("-").join("/") }}</h2>
				</div>
				<div v-if="parcela.pra_quantidade > 0" class="infos">
					<h6>Entrada</h6>
					<h2>R$ {{ parcela.valor_entrada }}</h2>
				</div>
				<div class="infos">
					<h6>Parcelas</h6>
					<h2 v-if="parcela.pra_quantidade === 0" class="titleOption">
						{{ `1x de R$ ${money2(parcela.valor_total)}` }}
					</h2>
					<h2 v-else class="titleOption">
						{{ `${parcela.pra_quantidade}x de R$ ${parcela.valor_parcela}` }}
					</h2>
				</div>
				<div class="infos">
					<h6>Valor total</h6>
					<h2 v-if="parcela.valor_total">R$ {{ money2(parcela.valor_total) }}</h2>
					<h2 v-else>R$ {{ money2(parcela.valor_total_acordo) }}</h2>
				</div>
			</div>
		</template>
		<template v-else-if="parcela.tipo_parcela === 'cartao'">
			<h3 class="titleOption">
				{{ `Confirmação de pagamento (${parcela.parcelamento}x de R$ ${parcela.valor_parcela})` }}
			</h3>
			<div class="infos-row" v-if="parcela">
				<div class="infos">
					<h6>Forma de pagamento</h6>
					<h2>Cartão de crédito</h2>
				</div>
				<div class="infos">
					<h6>Parcelas</h6>
					<h2 class="titleOption">
						{{ `${parcela.parcelamento}x de R$ ${parcela.valor_parcela}` }}
					</h2>
				</div>
				<div class="infos">
					<h6>Valor total</h6>
					<h2>R$ {{ money2(parcela.valor_total) }}</h2>
				</div>
			</div>
			<h3 class="titleOption">Dados do cartão de crédito</h3>
			<div class="infos-row px-3" v-if="parcela">
				<FormFields @save="savePayment" @update:values="inputsValues = $event" :fields="fieldsCard" />
			</div>
		</template>
		<h3 class="titleOption">Confirmação do acordo</h3>
		<div class="infos">
			<h6 class="text-cofirm">
				{{ parceiroConfig.sessoes.customization.campos.myDebits.detailsMonthlyPayment && parceiroConfig.sessoes.customization.campos.myDebits.detailsMonthlyPayment.textConfirmaAcordo ? parceiroConfig.sessoes.customization.campos.myDebits.detailsMonthlyPayment.textConfirmaAcordo : "Ao clicar em ‘Confirmar Acordo’ o cliente CONCORDA com os valores, datas e forma de pagamento apresentados bem como, com as regras de negociação do Credor. O Portal AcerteAqui envia diariamente informações de pagamento das parcelas ao Credor, para que o mesmo cumpra com as determinações legais junto aos órgãos de proteção ao crédito." }}
			</h6>
			<div @click="checkTerm = !checkTerm" class="checkTerm">
				<i :class="checkTerm ? 'far fa-check-square' : 'far fa-square'" />
				Eu concordo com as condições de pagamento
			</div>
		</div>
		<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corPrimaria : 'var(primaryColor)'" @click.native="savePayment()" text="Confirmar acordo" />
	</div>
</template>

<script>
import globalMethods from "../../../../mixins/globalMethods";
import ButtonDefault from "../../../../components/buttons/ButtonDefault";
import { mapActions, mapMutations, mapState } from "vuex";
import Template from "../../../admin/Template";
import FormFields from "../../../../components/FormFields";
export default {
	name: "DetailsMonthlyPayment",
	components: { FormFields, Template, ButtonDefault },
	mixins: [globalMethods],
	props: ["parcela", "divida", "formaPagamento"],
	data() {
		return {
			checkTerm: false,
			fieldsCard: [],
			inputsValues: {}
		};
	},
	mounted() {
		this.fieldsCard = [
			{
				variableName: "card_number",
				fieldType: "TextFieldMask",
				label: "Número do cartão",
				type: "text",
				cols: "7",
				maskFormat: "####.####.####.####",
				placeholder: "XXXX.XXXX.XXXX.XXXX"
			},
			{
				variableName: "valid_date",
				fieldType: "TextFieldMask",
				label: "Data de validade (mês/ano)",
				type: "text",
				cols: "5",
				maskFormat: "##/##",
				placeholder: "MM/AA"
			},
			{
				variableName: "cvv",
				fieldType: "TextFieldMask",
				label: "CVV (código de segurança)",
				type: "text",
				cols: "4",
				maskFormat: "###",
				placeholder: "XXX"
			},
			{
				variableName: "name",
				fieldType: "TextField",
				label: "Nome impresso no cartão",
				type: "text",
				cols: "8"
			}
		];
	},
	computed: {
		...mapState({
			showMessageModal: (state) => state.messageModal.show,
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig
		}),

		formaPagamentoFormatada() {
			switch (this.formaPagamento) {
				case 'pix':
					return 'PIX';
				case 'cartao':
					return 'Cartão de Crédito';
				case 'boleto':
					return 'Boleto';
				case 'link':
					return 'Link de Pagamento';
			}
		}
	},
	methods: {
		...mapMutations(["CHANGE_MESSAGE_MODAL"]),
		...mapActions(["action_salvarAcordo", "action_salvar_etapa"]),
		savePayment() {
			if (this.checkTerm) {
				this.action_salvar_etapa({
					pes_codigo: this.divida.pes_codigo,
					esn_fk_ets_codigo: 28,
					emp_codigo: this.parceiroConfig.emp_codigo,
					loj_codigo: this.divida.loj_codigo
				}).then((response) => {});
				let obj = {};
				if (this.parcela.tipo_parcela === "boleto") {
					obj = {
						pes_codigo: this.divida.pes_codigo,
						loj_codigo: this.divida.loj_codigo,
						pra_codigo: this.parcela.pra_codigo,
						aco_origem: "S",
						emp_codigo: this.divida.emp_codigo,
						primeiro_vencimento: this.parcela.pra_primeiro_vcto.split("-").join("/"),
						valor_entrada: this.parcela.valor_entrada,
						valor_parcela: this.parcela.valor_parcela,
						credit_card_payment: false,
						forma_pagamento: this.formaPagamento
					};

					this.action_salvarAcordo(obj).then((response) => {
						if (response.data.retorno) {
							this.$router.push({ name: "MyAgreements" });
						}
					});
				} else if (this.parcela.tipo_parcela === "cartao") {
					let { card_number, valid_date, cvv, name } = this.inputsValues;
					if (!card_number || card_number.length !== 19) {
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Número do cartão inválido!",
							message: `Por favor, digite o número impresso em seu cartão de crédito`,
							styleMessage: "danger"
						});
					} else if (!valid_date || valid_date.length !== 5 || valid_date.split("/")[0] < "01" || valid_date.split("/")[0] > "12" || valid_date.split("/")[1] < this.dateNowFormat("YY") || valid_date.split("/")[1] > "50" || (valid_date.split("/")[1] === this.dateNowFormat("YY") && valid_date.split("/")[0] <= this.dateNowFormat("MM"))) {
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Data de validade do cartão inválida!",
							message: `Por favor, digite o mês e ano (MM/AA) de validade impresso em seu cartão de crédito`,
							styleMessage: "danger"
						});
					} else if (!cvv || cvv.length !== 3) {
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Código de segurança do cartão inválido!",
							message: `Por favor, digite o código de segurança de três digitos, impresso no verso do seu cartão de crédito`,
							styleMessage: "danger"
						});
					} else if (!name || name.length <= 7 || name.replace(" ", "").length === 0) {
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Nome do titular do cartão inválido!",
							message: `Por favor, digite o nome do titular impresso em seu cartão de crédito`,
							styleMessage: "danger"
						});
					} else {
						obj = {
							pes_codigo: this.divida.pes_codigo,
							loj_codigo: this.divida.loj_codigo,
							pra_codigo: this.parcela.pra_codigo,
							aco_origem: "S",
							emp_codigo: this.divida.emp_codigo,
							primeiro_vencimento: this.parcela.pra_primeiro_vcto ? this.parcela.pra_primeiro_vcto.split("-").join("/") : undefined,
							valor_entrada: "0",
							valor_parcela: this.parcela.valor_parcela,
							credit_card_payment: true,
							cartao: {
								vencimento_cartao: valid_date,
								parcelamento: parseInt(this.parcela.parcelamento),
								numero_cartao: this.removeMaskCharacters(card_number),
								cvv: cvv,
								nome: name
							},
							forma_pagamento: this.formaPagamento
						};
						this.action_salvarAcordo(obj).then((response) => {
							if (response.data.retorno) {
								this.$router.push({ name: "MyAgreements" });
							}
						});
					}
				}
			} else {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Confirme as condições de pagamento",
					message: `Por favor, concorde com as condições de pagamentos para confirmar este acordo`,
					styleMessage: "danger"
				});
			}
		}
	}
};
</script>

<style scoped>
h3 {
	margin-top: 20px;
	color: #031b4e;
	font-family: "Roboto Black";
	text-transform: uppercase;
	font-size: 16px;
	text-align: center;
	background: #f5f6fa;
	padding: 10px 0;
}

.iconBoxBack {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-family: "Roboto Black";
	color: var(--primaryColor);
	text-transform: uppercase;
	cursor: pointer;
}

.iconBoxBack i {
	margin-right: 10px;
	font-size: 22px;
}

.infos-row {
	margin: 20px 0;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
}

.infos {
	padding: 20px;
}

.infos h6 {
	color: #5b6987;
	font-family: "Roboto";
	font-size: 11px;
	margin-bottom: 3px;
}

.infos h2 {
	color: #031b4e;
	font-family: "Roboto Black";
	font-size: 18px;
}

.img-box {
	width: 110px;
	height: 110px;
	display: flex;
	justify-content: center;
	align-items: center;
	object-fit: cover;
}

.img-box img {
	object-fit: cover;
	width: 110px;
}

.checkTerm {
	color: #031b4e;
	margin: 20px 0 10px 0;
	font-size: 14px;
	font-family: "Roboto Bold";
	display: flex;
	justify-content: flex-start;
	align-items: center;
	cursor: pointer;
}

.checkTerm i {
	font-size: 20px;
	margin: 0 5px 0 0;
}

.px-3 {
	padding: 15px;
}

h6.text-cofirm {
	font-size: 14px;
	line-height: 20px;
	text-align: justify;
}
</style>
